module.exports = __webpack_public_path__ + "static/media/klapper.ab321165.png";